import { BaseRepository } from "./BaseRepository";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * NFT 관련 데이터를 처리하는 Repository 클래스입니다.
 */
export class NFTRepository extends BaseRepository {
  constructor() {
    super();
  }

  /**
   * 지갑 주소로 NFT 정보를 조회합니다.
   * @param {string} address - 지갑 주소
   * @returns {Promise<Array>} NFT 정보 목록
   * @throws {Error} API 호출 실패 시 에러
   */
  async findByAddress(address) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/v1/nft/${address}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "NFT 정보 조회에 실패했습니다.");
      }

      return await response.json();
    } catch (error) {
      console.error("Error in findByAddress:", error);
      throw error;
    }
  }

  /**
   * NFT 이미지를 변경합니다.
   * @param {string} address - 지갑 주소
   * @param {number} nftInfoId - NFT Info ID
   * @param {string} metadata - NFT 메타데이터
   * @returns {Promise<Object>} 업데이트된 NFT 정보
   * @throws {Error} API 호출 실패 시 에러
   */
  async updateImage(address, nftInfoId, tierId, imageId) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/nft/${address}/metadata`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            nftInfoId,
            tierId,
            paymentId: imageId,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "NFT 이미지 변경에 실패했습니다.");
      }

      return await response.json();
    } catch (error) {
      console.error("Error in updateImage:", error);
      throw error;
    }
  }
}
